<ng-container *ngIf="dropdown; else noDropdown">
  <div class="block relative" [matMenuTriggerFor]="calendarTextSelect">
    <div
      class="w-5 h-5 flex justify-center items-center absolute top-[10px] left-3 cursor-pointer"
    >
      <ui-icon [attr.name]="icon" fill="neutrals-900" m-size="20" size="20" />
    </div>
    <input
      class="w-full h-[40px] min-h-[40px] max-h-[40px] box-border py-4 bg-neutrals-0 rounded-[8px] border-neutrals-400 pl-10 pr-9 cursor-pointer"
      type="text"
      [value]="value"
      [placeholder]="placeholder"
      readonly
    />
    <button
      class="w-5 h-5 flex justify-center items-center absolute right-2 top-[10px]"
    >
      <ui-icon name="chevron-down" fill="neutrals-900" m-size="20" size="20" />
    </button>
  </div>

  <mat-menu #calendarTextSelect="matMenu" class="w-[300px] mt-[14px]">
    <mat-calendar
      (click)="$event.stopPropagation()"
      class="bg-neutrals-0 rounded-[8px] p-[14px]"
      [(selected)]="datetime"
      [minDate]="today"
      [maxDate]="maxDate"
      (selectedChange)="onSelectedDate($event)"
    ></mat-calendar>
  </mat-menu>
</ng-container>

<ng-template #noDropdown>
  <div class="block relative">
    <div
      class="w-5 h-5 flex justify-center items-center absolute top-[10px] left-3"
    >
      <ui-icon [attr.name]="icon" fill="neutrals-900" m-size="20" size="20" />
    </div>
    <input
      class="w-full h-[40px] min-h-[40px] max-h-[40px] box-border py-4 bg-neutrals-0 rounded-[8px] border-neutrals-400 pl-10 pr-9"
      type="text"
      [value]="value"
      [placeholder]="placeholder"
      readonly
    />
  </div>
</ng-template>
